import { getDatabase, push, ref, set } from "firebase/database";
import moment from "moment";
import { TextsProps } from "../database/txt.interface";
import { ServicosProps } from "../interfaces/config.interface";
import { Exercicios2Props } from "../interfaces/exercicio.interface";
import { PacientesProps, UserProps } from "../interfaces/pacientes.interface";
import { AppActions } from "../store/ducks/app";
import { AuthActions } from "../store/ducks/auth";
import { TypesPermission, TypesDivision, TypesLanguage } from "./types";
import { useSelector } from "react-redux";
import { DashBoardActions } from "../store/ducks/dashboard";
import { Dispatch } from "redux";
import { loadStorage, persistStorage } from "./base_async_storage";


export function getGroupingSide(side: any, current_language: TextsProps) {
	if (side == "D") {
		return current_language?.hemisferio_direito;
	}
	if (side == "E") {
		return current_language?.hemisferio_esquerdo;
	}
	if (side == "B") {
		return current_language?.hemisferio_bilateral;
	}
	if (side == "S") {
		return current_language?.sem_hemisferio;
	}
}

export function getElementsExers(
	exer: Exercicios2Props,
	type: any,
	T: any,
	current_language: TextsProps,
	language: any
) {
	const DEB = type == TypesDivision.DEB ? ["D", "E", "B"] : ["S"];
	const aux_tipo = T.split("");

	const arr: any = [];

	aux_tipo.forEach((e: any) => {
		if (DEB.includes(e)) {
			arr.push({
				title:
					e == "D"
						? current_language?.hemisferio_direito
						: e == "E"
						? current_language?.hemisferio_esquerdo
						: e == "B"
						? current_language?.hemisferio_bilateral
						: current_language?.sem_hemisferio,
				value: e,
				exercice_id: exer?.ID_EXERCICIO,
				grupo: exer?.ID_AGRUPAMENTO,
				name:
					language == TypesLanguage.PT
						? exer?.EXERCICIO_TITULO_PT
						: language == TypesLanguage.EN
						? exer?.EXERCICIO_TITULO_EN
						: exer?.EXERCICIO_TITULO_ES,
			});
		}
	});
	return arr;
}

export function getPermission(
	config_servicos: ServicosProps[],
	type: any,
	dispatch?: any,
) {
	return config_servicos[type] || false;
}

export function getTimeExecFunction(tempInitial: number, tempFinal: number, description: string, user?: UserProps ) {
	const dataAtual = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
	const result = tempFinal - tempInitial
	const data = {
		user: user,
		moment: dataAtual,
		resultTime: result,
	}

	try{
		const firebaseDataBase = getDatabase();
			push(ref(firebaseDataBase, description), {
				id_user: data?.user?.ID_USUARIO,
				current_date: data.moment,
				ResultTime: data.resultTime,

			})
	}catch(error){
		console.log( 'Seus dados não foram enviados', error)
	}
};

export function getTimeout(tempInitial: number, tempFinal: number, description: string, user?: UserProps ){
	const dataAtual = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
	const result = tempFinal - tempInitial
	const timeout = {
		user: user,
		moment: dataAtual,
		timeout: result,
	};

	try{
		const firebaseDataBase = getDatabase();
		if(result >= 60000){
			push(ref(firebaseDataBase, description), {
				id_user: timeout?.user?.ID_USUARIO,
				current_date: timeout.moment,
				timeout: timeout.timeout,

			})
		}
	}catch(error){
		console.log( 'Seus dados não foram enviados', error)
	}
};

/**
 * 
 * @param pagina_desejada Number of the page you want to load the patient list
 * @param numero_de_paginas Represents the total number of existing pages (total number of patients divided by 6 - Number of patients per page)
 * @param dispatch redux dispatch (used to trigger an action)
 */
export function MudarPagina  (
	pagina_desejada: number,
	numero_de_paginas: number,
	dispatch: Dispatch,
	value?: Array<number>,
	SearchName?: any,
	quantidade_usuarios_por_pagina?: number
 ) {
	//Caso queira alterar o numero de pacientes por pagina
	//Alterar também no ducks dashboard para primeira requisição
	const usuarios_por_pagina = quantidade_usuarios_por_pagina ?? 6;
	const usuarios_na_pagina = [];

	dispatch(DashBoardActions.set_current_page_patient(pagina_desejada));

	if (pagina_desejada != null && pagina_desejada <= numero_de_paginas) {
		const indiceInicial = (pagina_desejada - 1) * usuarios_por_pagina;
		const indiceFinal = indiceInicial + usuarios_por_pagina;
		for (let i = indiceInicial; i <= indiceFinal; i++) {
			usuarios_na_pagina.push(i);
		}

		const filtros_paginacao = {
			inicio: usuarios_na_pagina[0],
			fim: usuarios_na_pagina[usuarios_por_pagina],
			filtros: [
				{ tipo: "USUARIO_EXCLUIDO", valor: "N" },
				{ tipo: "USUARIO_NIVEL", valor: value },
			],
		};
		if (SearchName != "") {
			filtros_paginacao.filtros.push({ tipo: "USUARIO_NOME", valor: SearchName });
		}

		dispatch(
			DashBoardActions.set_filtros_pacintes_request(filtros_paginacao)
		);
		dispatch(DashBoardActions.paciente_request());
		
		if(value?.includes(1) && value?.includes(2)){

			dispatch(DashBoardActions.set_current_page_evaluator(pagina_desejada));
			dispatch(
				DashBoardActions.set_filtros_avaliadores_request(filtros_paginacao)
			);
			dispatch(DashBoardActions.avaliadores_request());
		}
	} else {
		console.log(`A página ${pagina_desejada} não existe.`);
	}
};

export async function getEvaluatedPatients(paciente: PacientesProps) {
		
	let evaluatedPatients: number[] | null = []

	evaluatedPatients = await loadStorage('evaluated_patients')

	if(!evaluatedPatients?.includes(paciente?.ID_USUARIO)){
		
		evaluatedPatients?.push(paciente?.ID_USUARIO)

		persistStorage({
			res: evaluatedPatients,
			tag: 'evaluated_patients',
		});

	};
};

export function setMaskPhone(text: string) {
	enum MaskProps {
		text = 'text',
		justNumbers = 'justNumbers'
	};
	const justNumbers =  text.replace(/\D/g, '')

	const handleMask = {
		text: text,
		justNumbers : justNumbers
	};

	const mask = handleMask[text?.length >= 2 ? MaskProps?.justNumbers : MaskProps?.text ].replace(/^(\d{0,2})?(\d{0,5})?(\d{0,4})?/, (match, ddd, prefix, sufix)=> {
		return (
		  (ddd ? `(${ddd}` : '') +
		  (prefix ? `) ${prefix}` : '') +
		  ((prefix && sufix) ? '-' : '') +
		  (sufix || '')
		);
	});
	
	return mask
};

export function setMaskCPF(input: string) {
	const justNumbers = input.replace(/\D/g, '');
	const mask = justNumbers.replace(/^(\d{0,3})?(\d{0,3})?(\d{0,3})?(\d{0,2})?/, (match, group1, group2, group3, group4)=> {
	  return (
		(group1 ? `${group1}.` : '') +
		(group2 ? `${group2}.` : '') +
		(group3 ? `${group3}-` : '') +
		(group4 || '')
	  );
	});
	
	if (mask.slice(-1) === '-' || mask.slice(-1) === '.') {
		return mask.slice(0, -1);
	}
  
	return mask;
};

export function setMaskBirthDate(input: string): string {
	const justNumbers = input.replace(/\D/g, '');

	const match = justNumbers.match(/^(\d{0,2})(\d{0,2})(\d{0,4})/);
	if (!match) return '';

	let [_, day, month, year] = match;

	// Limita valores apenas se completos
	if (day) {
		const dayNum = parseInt(day, 10);
		if (!isNaN(dayNum)) {
		day = Math.min(dayNum, 31).toString().padStart(day.length, '0');
		}
	}

	if (month) {
		const monthNum = parseInt(month, 10);
		if (!isNaN(monthNum)) {
		month = Math.min(monthNum, 12).toString().padStart(month.length, '0');
		}
	}

	if (year && year.length === 4) {
		const yearNum = parseInt(year, 10);
		const currentYear = new Date().getFullYear();
		if (yearNum < 1900) {
		year = '1900';
		} else if (yearNum > currentYear) {
		year = currentYear.toString();
		}
	}

	const masked =
		(day ? `${day}` : '') +
		(month ? `/${month}` : '') +
		(year ? `/${year}` : '');

	return masked;
}

export function setMaskWeight(input: string): string {
	const justNumbers = input.replace(/\D/g, '');

	// Preenche à esquerda com zeros se tiver menos de 3 dígitos
	const padded = justNumbers.padStart(3, '0');

	const intPart = padded.slice(0, -2);
	const decimalPart = padded.slice(-2);

	return `${parseInt(intPart, 10)},${decimalPart}`;
}

export function setMaskHeight(input: string): string {
	const justNumbers = input.replace(/\D/g, '');

	const mask = justNumbers.replace(/^(\d{0,1})(\d{0,2})/, (_, intPart, decimalPart) => {
	  return (
		(intPart ? `${intPart}` : '') +
		(decimalPart ? `,${decimalPart}` : '')
	  );
	});
  
	return mask;
}
export function formatCNPJ(value: string): string {
  const cleaned = value.replace(/\D/g, ''); 

  const cnpjFormatted = cleaned
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})(\d)/, '.$1/$2')
    .replace(/(\d{4})(\d)/, '$1-$2')
    .slice(0, 18); 

  return cnpjFormatted;
}


export function formatDominant(dominant: string, current_language: TextsProps) {
	let setDominant = '';
	if(dominant === 'E') setDominant = current_language?.canhoto;
	if(dominant === 'D') setDominant = current_language?.destro;
	return setDominant;
};

export function formatDominantForSave(dominant: string, current_language: TextsProps) {
	let setDominant = '';
	if(dominant === current_language?.canhoto) setDominant = 'E';
	if(dominant === current_language?.destro) setDominant = 'D';
	return setDominant;
};
export function formatCreditCardNumber(input: string) {

	if(!input) return ''
	const digitsOnly = input.replace(/\D/g, '');
  const formatted = digitsOnly.match(/.{1,4}/g)?.join(' ') || '';
  return formatted;
};
export function maskMonth(input: string) {

	if(!input) return ''
  const somenteNumeros = input.replace(/\D/g, '');
  return somenteNumeros.slice(0, 2);
	
};
export function maskYear(input: string) {

	if(!input) return ''
  const somenteNumeros = input.replace(/\D/g, '');
  return somenteNumeros.slice(0, 4);

};
export function maskCvv(input: string) {

	if(!input) return ''
  const somenteNumeros = input.replace(/\D/g, '');
  return somenteNumeros.slice(0, 3);

};
  